<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <h5 class="card-title mb-0">
          {{ trans("admin.cdr.flagDetail") }} #{{ flag.id }}
          &nbsp;&nbsp;
          <span
            :class="statusClass(flag.status)"
            style="font-size: 0.75rem; vertical-align: middle"
          >
            {{ flag.status_label }}
          </span>
        </h5>
        <slot name="actions" />
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.type") }}:</strong>
          {{ flag.flaggable_type_label }}
          <span v-if="flag.flaggable?.id" class="text-muted">
            (ID: {{ flag.flaggable.id }})
          </span>
        </div>
        <div class="col-md-6">
          <strong>{{ trans("admin.draftExaminations.centre") }}:</strong>
          {{ flag.flaggable?.center?.name }}
        </div>
      </div>

      <div class="row mb-3">
        <div v-if="flag.flaggable?.case_no" class="col-md-6">
          <strong>{{ trans("admin.cdr.caseNo") }}:</strong>
          {{ flag.flaggable.case_no }}
        </div>
        <div v-if="flag.flaggable?.ssn" class="col-md-6">
          <strong>{{ trans("admin.cdr.lookupSsn") }}:</strong>&nbsp;
          <template v-if="ssnVisible">
            {{ flag.flaggable.ssn }}
          </template>
          <template v-else> ******** </template>
          &nbsp;
          <button
            type="button"
            class="btn btn-link btn-sm p-0"
            @click="ssnVisible = !ssnVisible"
          >
            <i :class="ssnVisible ? 'fal fa-eye-slash' : 'fal fa-eye'" />
          </button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.reasonCategory") }}:</strong>
          {{ flag.reason_label }}
        </div>
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.requestedAction") }}:</strong>
          {{ flag.requested_action_label }}
        </div>
      </div>

      <div v-if="flag.destination_patient_note" class="row mb-3">
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.destinationPatientNote") }}:</strong>
          {{ flag.destination_patient_note }}
        </div>
      </div>

      <div v-if="flag.wound_cascade_acknowledgement_label" class="row mb-3">
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.woundCascadeAcknowledgement") }}:</strong>
          {{ flag.wound_cascade_acknowledgement_label }}
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.flaggedBy") }}:</strong>
          {{ flag.flagged_by?.full_name }}
        </div>
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.flaggedAt") }}:</strong>
          {{ flag.created_at_formatted }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { statusClass } from "./cdr-flag-status";

export default {
  props: {
    flag: { type: Object, required: true },
  },
  data() {
    return {
      ssnVisible: false,
    };
  },
  methods: {
    statusClass,
  },
};
</script>
